/*
 * @Description:
 * @Date: 2020-11-11 10:00:09
 * @LastEditors: jml
 * @LastEditTime: 2020-12-05 17:08:02
 */
import echarts from 'echarts';
import { convertData } from './map';
const CubeTop = echarts.graphic.extendShape({
  shape: {
    x: 0,
    y: 0
  },
  buildPath: function(ctx, shape) {
    const c1 = [shape.x + 9, shape.y];
    const c2 = [shape.x + 12, shape.y - 8];
    const c3 = [shape.x - 8, shape.y - 8];
    const c4 = [shape.x - 12, shape.y];
    ctx
      .moveTo(c1[0], c1[1])
      .lineTo(c2[0], c2[1])
      .lineTo(c3[0], c3[1])
      .lineTo(c4[0], c4[1])
      .closePath();
  }
});
const CubeRight = echarts.graphic.extendShape({
  shape: {
    x: 0,
    y: 0
  },
  buildPath: function(ctx, shape) {
    const xAxisPoint = shape.xAxisPoint;
    const c1 = [shape.x + 9, shape.y];
    const c2 = [xAxisPoint[0] + 9, xAxisPoint[1]];
    const c3 = [xAxisPoint[0] + 12, xAxisPoint[1]];
    const c4 = [shape.x + 12, shape.y - 8];
    ctx
      .moveTo(c1[0], c1[1])
      .lineTo(c2[0], c2[1])
      .lineTo(c3[0], c3[1])
      .lineTo(c4[0], c4[1])
      .closePath();
  }
});
const CubeForward1 = echarts.graphic.extendShape({
  shape: {
    x: 0,
    y: 0
  },
  buildPath: function(ctx, shape) {
    const xAxisPoint = shape.xAxisPoint;
    const c1 = [shape.x - 12, shape.y];
    const c2 = [xAxisPoint[0] - 12, xAxisPoint[1]];
    const c3 = [xAxisPoint[0] - 6, xAxisPoint[1]];
    const c4 = [shape.x - 6, shape.y];
    ctx
      .moveTo(c1[0], c1[1])
      .lineTo(c2[0], c2[1])
      .lineTo(c3[0], c3[1])
      .lineTo(c4[0], c4[1])
      .closePath();
  }
});
const CubeForward2 = echarts.graphic.extendShape({
  shape: {
    x: 0,
    y: 0
  },
  buildPath: function(ctx, shape) {
    const xAxisPoint = shape.xAxisPoint;
    const c1 = [shape.x - 6, shape.y];
    const c2 = [xAxisPoint[0] - 6, xAxisPoint[1]];
    const c3 = [xAxisPoint[0] + 9, xAxisPoint[1]];
    const c4 = [shape.x + 9, shape.y];
    ctx
      .moveTo(c1[0], c1[1])
      .lineTo(c2[0], c2[1])
      .lineTo(c3[0], c3[1])
      .lineTo(c4[0], c4[1])
      .closePath();
  }
});

const CubeTop1 = echarts.graphic.extendShape({
  shape: {
    x: 0,
    y: 0
  },
  buildPath: function(ctx, shape) {
    const c1 = [shape.x, shape.y + 12];
    const c2 = [shape.x - 8, shape.y + 8];
    const c3 = [shape.x - 8, shape.y - 14];
    const c4 = [shape.x, shape.y - 9];
    ctx
      .moveTo(c1[0], c1[1])
      .lineTo(c2[0], c2[1])
      .lineTo(c3[0], c3[1])
      .lineTo(c4[0], c4[1])
      .closePath();
  }
});
const CubeRight1 = echarts.graphic.extendShape({
  shape: {
    x: 0,
    y: 0
  },
  buildPath: function(ctx, shape) {
    const xAxisPoint = shape.xAxisPoint;
    const c1 = [shape.x, shape.y + 12];
    const c2 = [xAxisPoint[0], shape.y + 12];
    const c3 = [xAxisPoint[0], shape.y + 7];
    const c4 = [shape.x - 8, shape.y + 7];
    ctx
      .moveTo(c1[0], c1[1])
      .lineTo(c2[0], c2[1])
      .lineTo(c3[0], c3[1])
      .lineTo(c4[0], c4[1])
      .closePath();
  }
});
const CubeForward11 = echarts.graphic.extendShape({
  shape: {
    x: 0,
    y: 0
  },
  buildPath: function(ctx, shape) {
    const xAxisPoint = shape.xAxisPoint;
    const c1 = [shape.x - 8, shape.y - 8];
    const c2 = [xAxisPoint[0], shape.y - 8];
    const c3 = [xAxisPoint[0], shape.y - 14];
    const c4 = [shape.x - 8, shape.y - 14];
    ctx
      .moveTo(c1[0], c1[1])
      .lineTo(c2[0], c2[1])
      .lineTo(c3[0], c3[1])
      .lineTo(c4[0], c4[1])
      .closePath();
  }
});
const CubeForward21 = echarts.graphic.extendShape({
  shape: {
    x: 0,
    y: 0
  },
  buildPath: function(ctx, shape) {
    const xAxisPoint = shape.xAxisPoint;
    const c1 = [shape.x - 8, shape.y - 9];
    const c2 = [xAxisPoint[0], shape.y - 9];
    const c3 = [xAxisPoint[0], shape.y + 8];
    const c4 = [shape.x - 8, shape.y + 8];
    ctx
      .moveTo(c1[0], c1[1])
      .lineTo(c2[0], c2[1])
      .lineTo(c3[0], c3[1])
      .lineTo(c4[0], c4[1])
      .closePath();
  }
});

const CubeCircle = echarts.graphic.extendShape({
  shape: {
    x: 0,
    y: 0
  },
  buildPath: function(ctx, shape) {
    ctx.arc(shape.x, shape.y, 4, 0, 360).closePath();
  }
});
const CubeLine = echarts.graphic.extendShape({
  shape: {
    x: 0,
    y: 0
  },
  buildPath: function(ctx, shape) {
    const xAxisPoint = shape.xAxisPoint;
    ctx
      .moveTo(shape.x, shape.y)
      .lineTo(shape.x, xAxisPoint[1])
      .closePath();
  }
});

const CubeOval = echarts.graphic.extendShape({
  shape: {
    x: 0,
    y: 0
  },
  buildPath: function(ctx, shape) {
    const width = shape.width || 25;
    const scale = shape.scale || 4;
    ctx
      .moveTo(shape.x, shape.y)
      .bezierCurveTo(
        shape.x,
        shape.y + width / scale,
        shape.x + width,
        shape.y + width / scale,
        shape.x + width,
        shape.y
      )
      .bezierCurveTo(
        shape.x + width,
        shape.y - width / scale,
        shape.x,
        shape.y - width / scale,
        shape.x,
        shape.y
      )
      .closePath();
  }
});
const CubeRect = echarts.graphic.extendShape({
  shape: {
    x: 0,
    y: 0
  },
  buildPath: function(ctx, shape) {
    const [c1, c2, c3, c4] = shape.points;
    ctx
      .moveTo(c1[0], c1[1])
      .lineTo(c2[0], c2[1])
      .lineTo(c3[0], c3[1])
      .lineTo(c4[0], c4[1])
      .closePath();
  }
});

echarts.graphic.registerShape('CubeOval', CubeOval);
echarts.graphic.registerShape('CubeRect', CubeRect);
echarts.graphic.registerShape('CubeCircle', CubeCircle);
echarts.graphic.registerShape('CubeLine', CubeLine);
echarts.graphic.registerShape('CubeTop', CubeTop);
echarts.graphic.registerShape('CubeRight', CubeRight);
echarts.graphic.registerShape('CubeForward1', CubeForward1);
echarts.graphic.registerShape('CubeForward2', CubeForward2);
echarts.graphic.registerShape('CubeTop1', CubeTop1); // 横向坐标
echarts.graphic.registerShape('CubeRight1', CubeRight1); // 横向坐标
echarts.graphic.registerShape('CubeForward11', CubeForward11); // 横向坐标
echarts.graphic.registerShape('CubeForward21', CubeForward21); // 横向坐标

const getShape = (api, location, isVertical, distanceX = 0, distanceY = 0) => {
  const arr = isVertical
    ? api.coord([api.value(0), 0])
    : api.coord([0, api.value(1)]);
  arr[0] += distanceX;
  arr[1] += distanceY;
  return {
    api,
    xValue: api.value(0),
    yValue: api.value(1),
    x: location[0] + distanceX,
    y: location[1] + distanceY,
    xAxisPoint: arr
  };
};

export const createBarSeries = (series0data, isVertical = false) => {
  return [
    {
      type: 'custom',
      z: 2,
      renderItem: function(params, api) {
        const location = api.coord([api.value(0), api.value(1)]);
        if (api.value(isVertical ? 1 : 0) > 0) {
          return {
            type: 'group',
            children: [
              {
                type: isVertical ? 'CubeRight' : 'CubeRight1',
                shape: getShape(api, location, isVertical),
                style: {
                  fill: '#4236ED'
                }
              },
              {
                type: isVertical ? 'CubeTop' : 'CubeTop1',
                shape: getShape(api, location, isVertical),
                style: {
                  fill: '#A29EFF'
                }
              },
              {
                type: isVertical ? 'CubeForward1' : 'CubeForward11',
                shape: getShape(api, location, isVertical),
                style: {
                  fill: '#7D76FF'
                }
              },
              {
                type: isVertical ? 'CubeForward2' : 'CubeForward21',
                shape: getShape(api, location, isVertical),
                style: {
                  fill: '#685FFF'
                }
              }
            ]
          };
        }
      },
      data: series0data
    },
    {
      type: 'bar',
      z: 1,
      legendHoverLink: false,
      barWidth: 15,
      label: {
        normal: {
          show: true,
          fontSize: 14,
          distance: 10,
          position: isVertical ? 'top' : 'right',
          color: '#666',
          formatter({ value }) {
            return value || '';
          }
        }
      },
      itemStyle: {
        normal: {
          color: '#685FFF',
          shadowColor: 'rgba(186, 202, 218, 1)',
          shadowBlur: 10,
          shadowOffsetY: isVertical ? 0 : 18,
          shadowOffsetX: isVertical ? 18 : 0
        }
      },
      data: series0data
    }
  ];
};

export const createLineSeries = series0data => {
  return [
    {
      symbol: 'circle',
      type: 'line',
      z: 3,
      lineStyle: {
        width: 0
      },
      itemStyle: {
        color: '#649BFF',
        borderColor: '#649BFF',
        borderWidth: 4,
        opacity: 1
      },
      label: {
        show: true,
        fontSize: 12,
        distance: 4,
        position: 'top',
        color: '#606266',
        formatter(v) {
          return v.value || '';
        }
      },
      areaStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: 'rgba(207, 233, 251, 1)'
          },
          {
            offset: 1,
            color: 'rgba(207, 233, 251, 0)'
          }
        ])
      },
      data: series0data
    },
    {
      type: 'custom',
      z: 2,
      silent: true,
      renderItem: function(params, api) {
        const location = api.coord([api.value(0), api.value(1)]);
        return {
          type: 'group',
          children: [
            {
              type: 'CubeLine',
              shape: getShape(api, location, true),
              style: {
                strokeWidth: 1,
                stroke: '#BEE2FA'
              }
            },
            // {
            //   type: 'CubeCircle',
            //   shape: getShape(api, location, true),
            //   style: {
            //     fill: '#649BFF'
            //   }
            // },
            {
              type: 'CubeLine',
              shape: getShape(api, location, true, 30),
              style: {
                strokeWidth: 1,
                stroke: 'rgba(191, 211, 225, .15)'
              }
            },
            {
              type: 'CubeCircle',
              shape: getShape(api, location, true, 30),
              style: {
                fill: 'rgba(191, 211, 225, .3)'
              }
            }
          ]
        };
      },
      data: series0data
    }
  ];
};

export const createBarCircleSeries = (series0data, isVertical = false) => {
  return [
    {
      type: 'custom',
      z: 2,
      silent: true,
      legendHoverLink: false,
      renderItem: function(params, api) {
        const location = api.coord([api.value(0), api.value(1)]);
        if (api.value(1) > 0) {
          return {
            type: 'group',
            children: [
              {
                type: 'CubeOval',
                shape: {
                  ...getShape(api, location, true, -13, -20),
                  width: 26
                },
                style: {
                  fill: 'rgba(114, 174, 255, .2)'
                }
              },
              {
                type: 'CubeOval',
                shape: {
                  ...getShape(
                    api,
                    location,
                    true,
                    -20,
                    api.coord([api.value(0), 0])[1] - location[1]
                  ),
                  width: 40
                },
                style: {
                  fill: 'rgba(208, 234, 255, 0.8)'
                },
                styleEmphasis: {
                  fill: 'rgba(208, 234, 255, 0.8)'
                }
              },
              {
                type: 'CubeRect',
                shape: {
                  points: [
                    [location[0] - 5, location[1] + 5],
                    [
                      api.coord([api.value(0), 0])[0] - 5,
                      api.coord([api.value(0), 0])[1]
                    ],
                    [
                      api.coord([api.value(0), 0])[0] - 5 + 10,
                      api.coord([api.value(0), 0])[1]
                    ],
                    [location[0] - 5 + 10, location[1] + 5]
                  ]
                },
                style: {
                  fill: 'RGBA(114, 174, 255, 1)'
                }
              },
              {
                type: 'CubeRect',
                shape: {
                  points: [
                    [location[0] - 12, location[1] + 3],
                    [
                      api.coord([api.value(0), 0])[0] - 12,
                      api.coord([api.value(0), 0])[1] - 2
                    ],
                    [
                      api.coord([api.value(0), 0])[0] - 12 + 8,
                      api.coord([api.value(0), 0])[1]
                    ],
                    [location[0] - 12 + 8, location[1] + 3]
                  ]
                },
                style: {
                  fill: 'rgba(154, 197, 255, 1)'
                }
              },
              {
                type: 'CubeRect',
                shape: {
                  points: [
                    [location[0] + 3, location[1] + 3],
                    [
                      api.coord([api.value(0), 0])[0] + 3,
                      api.coord([api.value(0), 0])[1]
                    ],
                    [
                      api.coord([api.value(0), 0])[0] + 3 + 8,
                      api.coord([api.value(0), 0])[1] - 2
                    ],
                    [location[0] + 3 + 8, location[1] + 3]
                  ]
                },
                style: {
                  fill: 'rgba(74, 151, 255, 1)'
                }
              },
              {
                type: 'CubeOval',
                shape: {
                  ...getShape(api, location, true, -12),
                  width: 23
                },
                style: {
                  fill: 'rgba(114, 174, 255, 1)',
                  stroke: '#fff',
                  lineWidth: 2
                }
              }
            ]
          };
        }
      },
      data: series0data
    },
    {
      type: 'bar',
      z: 1,
      legendHoverLink: false,
      barWidth: 15,
      label: {
        normal: {
          show: true,
          fontSize: 14,
          distance: 30,
          position: isVertical ? 'top' : 'right',
          color: '#666',
          formatter({ value }) {
            return value || '';
          }
        }
      },
      itemStyle: {
        normal: {
          color: '#685FFF',
          shadowColor: 'rgba(186, 202, 218, 1)',
          shadowBlur: 10,
          shadowOffsetY: isVertical ? 0 : 18,
          shadowOffsetX: isVertical ? 18 : 0
        }
      },
      data: series0data
    }
  ];
};

export const createMapSeries = (series0data, finalDataCount) => {
  return [
    {
      type: 'effectScatter',
      coordinateSystem: 'geo',
      geoIndex: 2,
      data: convertData(series0data),
      symbol: 'circle',
      rippleEffect: {
        period: 8,
        brushType: 'fill',
        scale: 3.5
      },
      symbolSize: function(val) {
        return (val[2] / finalDataCount) * 8 + 4;
      },
      label: {
        normal: {
          formatter: '{@[2]}',
          position: 'right',
          color: '#303030',
          fontSize: 9,
          show: true,
          offset: [4, 0]
        },
        emphasis: {
          show: true
        }
      },
      itemStyle: {
        color: '#FF2828'
      }
    }
  ];
};

export const createMapSeries1 = series0data => {
  return [
    {
      type: 'scatter',
      coordinateSystem: 'geo',
      geoIndex: 2,
      data: series0data.reduce((pre, cur) => {
        const { visitLongitude, visitLatitude, latitude, longitude } = cur;
        pre.push({
          value: [visitLongitude || longitude, visitLatitude || latitude]
        });
        return pre;
      }, []),
      symbol: 'circle',
      rippleEffect: {
        period: 8,
        brushType: 'fill',
        scale: 3.5
      },
      animation: false,
      symbolSize: function() {
        return 6;
      },
      label: {
        normal: {
          show: false
        },
        emphasis: {
          show: false
        }
      },
      itemStyle: {
        color: '#FF2828'
      }
    }
  ];
};
